import React from "react";
import { connect } from "react-redux";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../../../../store/AppDisplays";
import { isRemoteLoading, ReduxState } from "../../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { Filter } from "../../../../02-pages/Filter";
import { Results } from "../../../../02-pages/Results";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { ManualBookingsResults } from "../../../../../../../store/ManualBooking/Types";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: ManualBookingsResults;
}

type Props = StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.MANUAL_BOOKING_RESULTS),
    results: s.prop("remote").prop(RemoteScope.MANUAL_BOOKING_RESULTS),
});

/**
 *
 * @param props
 */
export class FreebookingAuditTrailComp
    extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Header
                        title={SubPageDisplay[SubPages.AUDIT_TRAIL_FREEBOOKING].title}
                        description={SubPageDisplay[SubPages.AUDIT_TRAIL_FREEBOOKING].description}
                        goBack={PageDisplay[Pages.AUDIT_TRAILS].path}
                    />
                    <Filter
                        loadingFilters={this.props.loadingFilters}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.MANUAL_BOOKING}
                    />
                    <Results
                        results={this.props.results}
                        loadingResults={this.props.loadingResults}
                        currentPage={SubPages.AUDIT_TRAIL_FREEBOOKING}
                        scope={RemoteScope.MANUAL_BOOKING_RESULTS}
                    />
                </Container>
            </Page>
        );
    }
}

/**
 *
 */
export const FreebookingAuditTrail = connect(
    mapStateToProps,
    {},
)((props: Props) => <FreebookingAuditTrailComp {...props}/>);
